var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-linkedin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin-logo",
    fill: "#A4B1CD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6,0 L2.4,0 C1.08,0 0,1.08 0,2.4 L0,21.6 C0,22.92 1.08,24 2.4,24 L21.6,24 C22.92,24 24,22.92 24,21.6 L24,2.4 C24,1.08 22.92,0 21.6,0 Z M7.2,20.4 L3.6,20.4 L3.6,9.6 L7.2,9.6 L7.2,20.4 Z M5.4,7.56 C4.2,7.56 3.24,6.6 3.24,5.4 C3.24,4.2 4.2,3.24 5.4,3.24 C6.6,3.24 7.56,4.2 7.56,5.4 C7.56,6.6 6.6,7.56 5.4,7.56 Z M20.4,20.4 L16.8,20.4 L16.8,14.04 C16.8,13.0800471 15.96,12.24 15,12.24 C14.04,12.24 13.2,13.0800471 13.2,14.04 L13.2,20.4 L9.6,20.4 L9.6,9.6 L13.2,9.6 L13.2,11.04 C13.8,10.08 15.12,9.36 16.2,9.36 C18.48,9.36 20.4,11.28 20.4,13.56 L20.4,20.4 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedin);
export default __webpack_public_path__ + "static/media/ic-linkedin.109e6e4815e03f40dda454a783c8375d.svg";
export { ForwardRef as ReactComponent };